import { ROUTES } from "../../../module/constants";

export interface IResetPasswordProps {}

export const STATE_IDENTIFIER = {
  USERS: "users",
  REQUEST_STATE: "requestState",
  SELECTED_USER: "selectedUser",
  SELECTED_ACCOUNT: "selectedAccount",
  PASSWORD_POLICY: "passwordPolicy",
};

export const CHANGE_PASSWORD_URLS = {
  BASE_URL: `${ROUTES.CHANGE_PASSWORD}`,
  STEP_TWO: `${ROUTES.CHANGE_PASSWORD}/step-two`,
};

export const LIST_IDENTIFIER = "list";

export const LOADER_IDENTIFIER = "loader";
